// extracted by mini-css-extract-plugin
export default {"address":"icons_address__-VDdu","phone":"icons_phone__4FMxv","email":"icons_email__SeYs8","hide":"icons_hide__3brED","show":"icons_show__rEh4w"};